<template>
  <MapModal
    class="newModelPosition"
    :modalNode="modalNode"
    :submitData="submitData"
    :submit="submit"
    :close="close"
    :title="simulationTitle"
    id="addTrafficSimulation"
  >
    <!-- {{ currentState }} -->
  </MapModal>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");

//按需加载
import { addTdeeeiorst, editTdeeeiorst } from "@/api/api";

import * as mapWork from "./trafficSimulation.js";
import _ from "lodash";
export default {
  name: "traffic-simulation-add",
  components: { MapModal },
  props: ["modalNodeData", "close", "currentState"],
  // props: {
  //   getSchemeTree: { type: Function },
  //   selectedScene: { type: Object },
  //   modalNodeData: { type: Array },
  //   close: {
  //     type: Function,
  //   },
  // },
  data() {
    return {
      show: false,
      data: [],
      simulationTitle: "新增模拟数据",
      modalNode: {
        trafficSimulationAdd: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: -750,
          },

          height: "auto", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "form",
            formData: {
              name: {
                md: 24,
                type: "input",
                title: "名称",
                placeholder: "请输入",
              },
              positionType: {
                md: 24,
                type: "radio",
                title: "路径选择",
                disabled: false,
                selectCreate: true,
                input: this.positionTypeInput,
                show: this.currentState == "add",
                options: [
                  {
                    name: "标点",
                    id: "1",
                  },
                  {
                    name: "导入",
                    id: "2",
                  },
                ],
              },
              position: {
                md: 24,
                type: "button",
                title: "标点",
                buttonTitle: "选点",
                click: this.pickPoint,
                show: this.currentState == "add",
                // show: true,
              },
              importData: {
                md: 24,
                type: "upload",
                title: "导入",
                buttonTitle: "上传",
                httpRequest: this.import,
                show: false,
              },
              speed: {
                md: 24,
                type: "select",
                title: "速度 m/s",
                disabled: false,
                selectCreate: true,
                change: this.speedChange,
                options: [
                  {
                    name: "慢速（30）",
                    id: "30",
                  },
                  {
                    name: "中速（45）",
                    id: "45",
                  },
                  {
                    name: "快速（60）",
                    id: "60",
                  },
                ],
              },
              interval: {
                md: 24,
                type: "select",
                title: "间隔 /s",
                disabled: false,
                selectCreate: true,
                change: this.intervalChange,
                options: [
                  {
                    name: "小（0.5）",
                    id: "0.5",
                  },
                  {
                    name: "中（1）",
                    id: "1",
                  },
                  {
                    name: "大（2）",
                    id: "2",
                  },
                ],
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "请选择",
                  trigger: "blur",
                },
              ],
              speed: [
                {
                  required: true,
                  message: "请选择",
                  trigger: "blur",
                },
              ],
              interval: [
                {
                  required: true,
                  message: "请选择",
                  trigger: "blur",
                },
              ],
            },
          },
        },
      },
      projectId: window.sessionStorage.getItem("nowProjectId"),
      submitData: {
        id: "",
        name: "",
        positionType: "1",
        position: [],
        importData: "",
        speed: "45",
        interval: "1",
      },
    };
  },
  computed() {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {},
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    speedChange() {
      mapWork.postAverageVelocity(this.submitData.speed);
      if (mapWork.routePointSet && mapWork.routePointSet[0]?.length > 1) {
        if (this.submitData.id == "") {
          // console.log(this.submitData.id);
          mapWork.simulationStart(mapWork.routePointSet[0]);
        } else {
          mapWork.clearCZML(this.submitData.id);
          mapWork.simulationStart(mapWork.routePointSet[0], this.submitData.id);
        }
      }
    },
    intervalChange() {
      mapWork.postIntervalvehicle(this.submitData.interval);
      if (mapWork.routePointSet && mapWork.routePointSet[0]?.length > 1) {
        if (this.submitData.id == "") {
          mapWork.simulationStart(mapWork.routePointSet[0]);
        } else {
          mapWork.clearCZML(this.submitData.id);
          mapWork.simulationStart(mapWork.routePointSet[0], this.submitData.id);
        }
      }
    },
    positionTypeInput(e) {
      // mapWork.init();
      if (e == "1") {
        this.modalNode.trafficSimulationAdd.content.formData.position.show = true;
        this.modalNode.trafficSimulationAdd.content.formData.importData.show = false;
      } else {
        this.modalNode.trafficSimulationAdd.content.formData.importData.show = true;
        this.modalNode.trafficSimulationAdd.content.formData.position.show = false;
      }
    },
    edit(e) {
      console.log(e);
    },
    delete(e) {
      console.log(e, e.id);
    },
    pickPoint(index) {
      // console.log(index);
      // 刷新数据
      mapWork.refresh(this.submitData);
      let text = 1; // 点的名称
      // let demonstration = _.debounce(function() {
      // 开启车辆模拟
      //   mapWork.simulationStart(mapWork.routePointSet[0]);
      // }, 1000);

      // 绘制点
      mapWork.addPathPoint(text, (e) => {
        // 获取点集合
        let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(
          e.graphic._position_draw
        );
        // 初始化数据
        if (mapWork.routePointSet.length == 0) {
          mapWork.routePointSet.push([]);
        }
        //把点集合存入 routePointSet
        mapWork.routePointSet[0].push([_lng, _lat, _alt]);
        // 点名称累加
        text += 1;
        // 绘制线
        mapWork.drawLine(mapWork.routePointSet[0]);
        this.submitData.position.push([_lng, _lat, _alt]);
        // 继续绘制点
        mapWork.addPathPoint(text);
        // 防抖函数触发车辆模拟
        // demonstration();
      });
    },
    import(e) {
      mapWork.refresh(this.submitData);
      // console.log(e);
    },
    submit() {
      console.log("播放", this.submitData, this.currentState);
      let { name, speed, interval, position } = this.submitData;
      switch (this.currentState) {
        case "add":
          if (position.length > 0) {
            let data = {
              projectId: this.projectId,
              pId: 0,
              name: name,
              speed: speed,
              interval: interval,
              bimTrafficSimulationContent: [],
              dataType: 1,
            };
            position.forEach((item) => {
              data.bimTrafficSimulationContent.push({
                contentValue: item.toString(),
              });
            });
            addTdeeeiorst(data)
              .then((res) => {
                let { code } = res.data;
                if (code == 200 || code == 204) {
                  this.$emit("refresh");
                  this.close();
                  this.$notify({
                    title: "保存成功",
                    message: "",
                    type: "success",
                    duration: 960,
                    offset: 320,
                  });
                } else {
                  this.$notify({
                    title: "保存失败",
                    message: "",
                    type: "error",
                    duration: 960,
                    offset: 320,
                  });
                }
              })
              .catch((err) => {
                console.log(err);
                this.$notify({
                  title: "保存失败",
                  message: "",
                  type: "error",
                  duration: 960,
                  offset: 320,
                });
              });
          } else {
            this.$message({
              message: "请选择路线",
              type: "error",
              offset: 100,
              showClose: true,
              duration: 1600,
            });
          }
          break;
        case "edit":
          console.log(this.submitData);
          if (position.length > 0) {
            let data = {
              id: this.submitData.id,
              projectId: this.projectId,
              pId: 0,
              name: name,
              speed: speed,
              interval: interval,
              bimTrafficSimulationContent: [],
              dataType: 1,
            };
            position.forEach((item) => {
              data.bimTrafficSimulationContent.push({
                contentValue: item.toString(),
              });
            });
            editTdeeeiorst(data)
              .then((res) => {
                let { code } = res.data;
                if (code == 200 || code == 204) {
                  this.$emit("refresh");
                  this.close();
                  this.$notify({
                    title: "保存成功",
                    message: "",
                    type: "success",
                    duration: 960,
                    offset: 320,
                  });
                } else {
                  this.$notify({
                    title: "保存失败",
                    message: "",
                    type: "error",
                    duration: 960,
                    offset: 320,
                  });
                }
              })
              .catch((err) => {
                console.log(err);
                this.$notify({
                  title: "保存失败",
                  message: "",
                  type: "error",
                  duration: 960,
                  offset: 320,
                });
              });
          }
          break;
        default:
          break;
      }
    },
    nodeClick() {},
    checkBoxClick() {},
    verification() {},
    scenerModelClose() {},
    init() {
      mapWork.refresh();
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {
    // console.log("????");
    mapWork.init();
  },
  watch: {
    currentState(newData, oldData) {
      if (newData == "add") {
        this.submitData.id = "";
        this.modalNode.trafficSimulationAdd.content.formData.position.show = true;
        this.modalNode.trafficSimulationAdd.content.formData.positionType.show = true;
        this.modalNode.trafficSimulationAdd.content.formData.importData.show = false;
        this.simulationTitle = "新增模拟数据";
      } else {
        this.modalNode.trafficSimulationAdd.content.formData.importData.show = false;
        this.modalNode.trafficSimulationAdd.content.formData.position.show = false;
        this.modalNode.trafficSimulationAdd.content.formData.positionType.show = false;
        this.simulationTitle = "编辑模拟数据";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
.el-scrollbar__bar.is-vertical {
  width: 6px;
  top: 2px;
}
.el-scrollbar__bar {
  position: absolute;
  right: 2px;
  bottom: 2px;
  z-index: 1;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 120ms ease-out;
}
.treeShape {
  background: none;
  @include elTreeNode2();
  max-height: initial;
  min-height: 100px;
}

.table {
  @include box_wh(320, 0);
  height: auto;
  // max-height: 500px;
  padding: 0;
  transition-property: max-height, width, overflow;
  transition-duration: 0.3s, 0.3s, 0.3s;
}
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  /deep/ .el-button {
    margin: 0;
    font-size: 14px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
</style>
